import type { InternalAxiosRequestConfig } from "axios";
import { useAuthStore } from "@/store/useAuthStore";
import { useLoaderStore } from "@/store/useLoaderStore";
import { useChannelStore } from "@/store/useChannelStore";
import { encrypt } from "@/utils/cipher";
import { IS_ENCRYPTION_ENABLED } from "@/constants/app";

const requestInterceptor = async (config: InternalAxiosRequestConfig) => {
  // Show loader for API requests
  useLoaderStore.getState().showLoader();

  // Get token from the auth store
  const token = useAuthStore.getState().token;

  console.log(token, "Token");

  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }

  // Inject channel parameter for analytics and reporting requests
  if (config.url && config.url.includes("/reporting/") && !config.url.includes("chat-pdf") && !config.url.includes("conversation/user/conversationIDs")) {
    if (config.method?.toLowerCase() === "post") {
      const channel = useChannelStore.getState().channel;
      config.data = {
        ...(config.data || {}),
        channel: channel,
      };
    }
  }

  // IMPORTANT:
  // Do not wrap/encrypt multipart FormData (file uploads). Doing so would replace
  // the FormData payload (and files) with a JSON object and the server will see
  // an empty/null form body.
  if (typeof FormData !== "undefined" && config.data instanceof FormData) {
    return config;
  }

  if (IS_ENCRYPTION_ENABLED) {
    const encryptedData = await encrypt(JSON.stringify(config.data));
    config.data = {
      requestData: encryptedData,
    };
  } else {
    config.data = {
      requestData: JSON.stringify(config.data),
    };
  }
  return config;
};

export default requestInterceptor;
